import { Typography } from 'antd';
import ColorDot from './ColorDot';

const { Text } = Typography;

// Widest the Class column may grow before its label truncates, in px. Leaves
// room for the four number columns within the wide sidebar (500px).
const CLASS_COLUMN_MAX_WIDTH = 140;

/**
 * Class cell for the hexagon and DSP Classification Results tables: swatch plus
 * label, truncated with a tooltip. The cap is on the Text rather than a column
 * `ellipsis`, which would switch the table to fixed layout.
 *
 * @param {object} props
 * @param {string} props.label - class name
 * @param {string} props.color - swatch color
 */
const ClassLabelCell = ({ label, color }) => (
	<Text
		ellipsis={{ tooltip: label }}
		style={{ display: 'block', maxWidth: CLASS_COLUMN_MAX_WIDTH, fontSize: '0.8rem' }}>
		<ColorDot color={color} />
		{label}
	</Text>
);

export default ClassLabelCell;
